namespace TabAurous.Inventory {
    export namespace ReOrderDetailsCustomService {
        export const baseUrl = 'Inventory/ReOrderDetailsCustom';

        export declare function Create(request: ReOrderDetailsRow, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReOrderDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/ReOrderDetailsCustom/Create",
            List = "Inventory/ReOrderDetailsCustom/List"
        }

        [
            'Create', 
            'List'
        ].forEach(x => {
            (<any>ReOrderDetailsCustomService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
